import React, { useState, useEffect, useCallback } from 'react';
import api from '../../../services/api';
import useAuth from '../../../hooks/useAuth';
import ScreenLoader from '../../HtmlElements/ScreenLoader'
import Alert from '../../HtmlElements/Alert';
import { Link } from 'react-router-dom';
import UserPreferenceSidebar from '../UserPreferenceSidebar';
import AccountList from './AccountList';
import UserList from './UserList';

const ManageAccounts = () => {
  useAuth(); // Ensure the user is authenticated
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState('accounts');

  return (
    <div className='user_profile_wrapper'>
      {loader === true && (<ScreenLoader />)}
      <div className='container-fluid'>
        <div className='user_profile_subblock'>
          <div className='row'>
            <div className='col-md-2' style={{borderRight: "solid 0.1rem #98A4AA33"}}>
              <div className='sidebar_profile'>
                <UserPreferenceSidebar />
              </div>
            </div>
            <div className='col-md-10'>
              <div className='row'>
                  {/* [START] => UPPER TABS */}
                  <div className="navbar navbar-expand-lg container-fluid custom_subnavbar" style={{zIndex: "0"}}>
                    <ul className="nav nav-tabs custom_nav_tab">
                      <li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "accounts" ? "active" : ""
                          }`}
                          onClick={() => {
                              setActiveTab("accounts");
                            }
                          }
                        >
                          Accounts
                        </a>
                      </li>
                      {<li className="nav-item">
                        <a
                          className={`nav-link ${
                            activeTab === "users" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("users")}
                        >
                          Users
                        </a>
                      </li>}
                      
                    </ul>
                  {/* [END] => UPPER TABS */}
                </div>
              </div>

              <div className='row' style={{minHeight: '100vh'}}>
                {activeTab == 'accounts' && <AccountList /> }
                {activeTab == 'users' && <UserList /> }
              </div>

            </div>  
          </div>      
        </div>
      </div>
    </div>
  );
};

export default ManageAccounts;
